import _isObject from 'lodash/isObject'
import _isNil from 'lodash/isNil'

const fit = {
  crop: 'crop',
}

const format = {
  png: 'png',
  jpeg: 'jpg',
}

const quality = {
  low: 25,
  medium: 50,
  high: 75,
  original: 100,
}

const pixelDensity = window.devicePixelRatio || 1.0

function combinePaths(...args) {
  let finalPath = ''

  ;[...args].forEach((path) => {
    if (path && path !== '') {
      path = path.startsWith('/') ? path.substring(1, path.length) : path
      path = path.endsWith('/') ? path.substring(0, path.length - 1) : path

      if (finalPath === '') {
        finalPath += path
      } else {
        finalPath += `/${path}`
      }
    }
  })

  return finalPath
}

function addQueryStringParams(str, query) {
  if (!str || !_isObject(query)) {
    return ''
  }

  Object.keys(query).forEach((key) => {
    const value = query[key]

    if (!_isNil(value)) {
      if (str.indexOf('?') > 0) {
        str += `&${key}=${value}`
      } else {
        str += `?${key}=${value}`
      }
    }
  })

  return str
}

function fileStackImageUrl(url, options = {}) {
  const baseUrl = 'https://cdn.filestackcontent.com'

  if (!url.startsWith(baseUrl)) {
    return url
  }

  url = url.replace(baseUrl, '')

  const imgId = url

  url = url.replace(imgId, '')

  let task = ''

  if (options.height) {
    task += `/resize=height:${options.height}`
  }

  task += '/auto_image/compress'

  return combinePaths(baseUrl, url, task, imgId)
}

function imgixImageUrl(url, options = {}) {
  options = options || {}

  const baseUrl = 'https://tablelistpro-assets.imgix.net'

  if (!url.startsWith(baseUrl)) {
    return url
  }

  const filePath = url.replace(baseUrl, '')

  const newUrl = combinePaths(baseUrl, filePath)

  options.dpr = `${pixelDensity}`

  if (!options.fit) {
    options.fit = fit.crop
  }

  if (!options.quality) {
    options.quality = quality.medium
  }

  if (!options.format) {
    options.format = format.jpeg
  }

  return addQueryStringParams(newUrl, options)
}

export default {
  combinePaths,
  addQueryStringParams,
  optimizedImageUrl(url, options) {
    return imgixImageUrl(fileStackImageUrl(url), options)
  },
}



// WEBPACK FOOTER //
// ./src/utils/urlUtils.js